import { SystemStyleObject } from '@chakra-ui/react'

export const LEXICAL_TEXT_CLASSES = {
  bold: 'c-editor-text--bold',
  italic: 'c-editor-text--italic',
  underline: 'c-editor-text--underline',
  strikethrough: 'c-editor-text--strikethrough',
  underlineStrikethrough: 'c-editor-text--underline-strikethrough',
}

export const theme = {
  heading: {
    h1: 'c-editor-text__title',
    h2: 'c-editor-text__section-title',
    h3: 'c-editor-text__caption-text',
  },
  link: 'c-editor-text__link',
  list: {
    listitem: 'c-editor-text__list-item',
    nested: {
      listitem: 'c-editor-text__nested-list-item',
    },
    olDepth: [
      'c-editor-text__list',
      'c-editor-text__list c-editor-text__ol2',
      'c-editor-text__list c-editor-text__ol3',
    ],
    ul: 'c-editor-text__list',
  },
  paragraph: 'c-editor-text__body-text',
  quote: 'c-editor-text__quote',
  text: LEXICAL_TEXT_CLASSES,
}

export const BRANDING_TEXT_CLASSES = {
  heading1: '.c-editor-text__title',
  heading2: '.c-editor-text__section-title',
  normal: '.c-editor-text__body-text',
  caption: '.c-editor-text__caption-text',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const textStyles: { [key in string]: any } = {
  [BRANDING_TEXT_CLASSES.heading1]: {
    fontSize: 'var(--branding-title-font-size, 36px)',
    fontFamily: 'var(--branding-title-font-family, "Roboto, sans-serif")',
  },
  [BRANDING_TEXT_CLASSES.heading2]: {
    fontSize: 'var(--branding-section-title-font-size, 24px)',
    fontFamily: 'var(--branding-section-title-font-family, "Roboto, sans-serif")',
  },
  [BRANDING_TEXT_CLASSES.caption]: {
    fontSize: 'var(--branding-caption-text-font-size, 16px)',
    fontFamily: 'var(--branding-caption-text-font-family, "Roboto, sans-serif")',
  },
  [BRANDING_TEXT_CLASSES.normal]: {
    fontSize: 'var(--branding-body-text-font-size, 16px)',
    fontFamily: 'var(--branding-body-text-font-family, "Roboto, sans-serif")',
  },
  '.c-editor-text__list': { padding: 0, margin: 0, listStylePosition: 'inside' },
  'ol.c-editor-text__list': { listStyleType: 'decimal' },
  'ul.c-editor-text__list': { listStyleType: 'disc' },
  '.c-editor-text__ol2': { listStyleType: 'upper-alpha' },
  '.c-editor-text__ol3': { listStyleType: 'lower-alpha' },
  '.c-editor-text__list-item': { margin: '0 32px' },
  '.c-editor-text__quote': {
    borderLeftColor: 'rgb(206, 208, 212)',
    borderLeftWidth: '4px',
    borderLeftStyle: 'solid',
    color: 'rgb(101, 103, 107)',
    fontSize: '15px',
    margin: 0,
    marginBottom: '10px',
    marginLeft: '20px',
    paddingLeft: '16px',
  },
  '.c-editor-text--bold': {
    fontWeight: 'bold',
  },
  '.c-editor-text--italic': {
    fontStyle: 'italic',
  },
  '.c-editor-text--underline': {
    textDecoration: 'underline',
  },
  '.c-editor-text--strikethrough': {
    textDecoration: 'line-through',
  },
  '.c-editor-text--underline-strikethrough': {
    textDecoration: 'underline line-through',
  },
  '.c-editor-text__link': {
    color: 'rgb(0, 108, 231)',
    textDecoration: 'none',
  },
  '.c-editor-text__link:hover': {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const styles: SystemStyleObject & { [key in string]: any } = {
  ...Object.keys(textStyles).reduce((acc, curr) => ({ ...acc, [`& ${curr}`]: textStyles[curr] }), {}),
  '& .c-editor-input': {
    resize: 'none',
    caretColor: 'rgb(5, 5, 5)',
    position: 'relative',
    tabSize: '1',
    outline: '0',
    padding: '0',
  },
  '& .c-editor-placeholder': {
    color: '#999',
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    top: '0',
    userSelect: 'none',
    display: 'inline-block',
    pointerEvents: 'none',
  },
  '& .c-merge-tag:hover': {
    backgroundColor: 'rgba(0,108,231,.1)',
  },
  '& .c-merge-tag__bracket': {
    backgroundColor: 'rgba(0,108,231,.1)',
    color: 'ge.blue',
  },
  '& .link-editor': {
    display: 'flex',
    position: 'absolute',
    top: '0',
    left: '0',
    zIndex: '10',
    maxWidth: '400px',
    width: '100%',
    opacity: '0',
    backgroundColor: '#fff',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.3)',
    borderRadius: '0 0 8px 8px',
    transition: 'opacity 0.5s',
    willChange: 'transform',
  },
  '& .link-editor .button': {
    width: '20px',
    height: '20px',
    display: 'inline-block',
    padding: '6px',
    borderRadius: '8px',
    cursor: 'pointer',
    margin: '0 2px',
  },
  '& .link-editor .button.hovered': {
    width: '20px',
    height: '20px',
    display: 'inline-block',
    backgroundColor: '#eee',
  },
  '& .link-editor .button i, & .actions i': {
    backgroundSize: 'contain',
    display: 'inline-block',
    height: '20px',
    width: '20px',
    verticalAlign: '-0.25em',
  },
}
